// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fX8F","left":"styles_left__3qi9A","desktopActions":"styles_desktopActions__-pwB4","title":"styles_title__IKj5T"};